import arrayToIdIndex from "@/client/helpers/arrayToIdIndex";

const unknownType = {
  id:    -1,
  name:  "Объект",
  about: "об объекте",
  title: 'Объект',
};

const apartmentTypes = [
  {
    id:      0,
    name:    "Квартира",
    about:   "о квартире",
    iconNew: "ApartmentLiving",
    icon:    "HomeIcon",
    title:   'Жилое',
  },
  {
    id:      1,
    name:    "Апартаменты",
    about:   "об апартаментах",
    iconNew: "ApartmentApartment",
    icon:    "ApartmentIcon",
    title:   'Апартаменты',
  },
  {
    id:      2,
    name:    "Помещение",
    about:   "о помещении",
    iconNew: "ApartmentBusiness",
    icon:    "CommercialIcon",
    title:   'Коммерческое',
  },
  {
    id:      3,
    name:    "Паркинг",
    about:   "о паркинге",
    iconNew: "ApartmentParking",
    icon:    "ParkingIcon",
    title:   'Паркинг',
  },
  {
    id:      4,
    name:    "Кладовка",
    about:   "о кладовке",
    iconNew: "ApartmentStore",
    icon:    "ParkingIcon",
    title:   'Кладовка',
  },
];

const dict = arrayToIdIndex(apartmentTypes);

const selectOptions = apartmentTypes.map(type => ({
  value: type.id,
  label: type.title,
}));

export const getById = ( id ) => dict[id] || unknownType;
export const getByApartment = ( apartment ) => dict[apartment.type_apart] || unknownType;
export const getSelectOptions = () => selectOptions;

export const list = apartmentTypes;
